import {ENDPOINT_ADMIN_ACTIVE_AUCS_LIST} from "../../constants/api";

const map = require('mn-utils/map');
const {
  apiRequestAdmin,
} = require('../ws');


const MOCK_ACTIVE_AUCTIONS = [
  {
    id: 'c8e846db-71cf-4a87-8f71-1220ac7bc995',
    order_id: 'c8e846db-71cf-4a87-8f71-1220ac7bc995',
    time_stamp: '2020-02-17T12:07:45',
    sc_code: 'EURS',
    sc_amount: '43.87',
    cc_code: 'ETH',
    cc_amount: '0.023',
    fiat_code: 'EUR',
    confirmation_timeout: '60',
    blockchain_timeout: '60',
    status: 'Pending',
    wallet_kind: 'lunu_wallet',
  },
  {
    id: 'c8e846db-71cf-4a87-8f71-1220ac7bc996',
    order_id: 'c8e846db-71cf-4a87-8f71-1220ac7bc996',
    time_stamp: '2020-02-17T12:07:45',
    sc_code: 'EURS',
    sc_amount: '43.87',
    cc_code: 'ETH',
    cc_amount: '0.023',
    fiat_code: 'EUR',
    confirmation_timeout: '60',
    blockchain_timeout: '60',
    status: 'Pending',
    wallet_kind: 'lunu_wallet',
  },
];


export function apiAdminActiveAuctionsList(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_ACTIVE_AUCS_LIST, params, () => {
    return {
      list: MOCK_ACTIVE_AUCTIONS,
    };
  }).then((v) => {
    return {
      ...v,
      list: map(v.list, (item) => {
        return {
          ...item,
          time: item.time || item.time_stamp,
        };
      }, []),
    };
  });
}
